import {
  BULK_DELETE_WARNING,
  BULK_LOCK_WARNING,
  BULK_UNLOCK_WARNING,
  ListMenuItem,
  Typography,
  newToast,
} from "@compass/core";
import { Permission, PermissionAction } from "generated/openApi";
import { isAuthorized } from "services";
import {
  ContributorMatchBulkUpdatePageState,
  contributorMatchBulkUpdatePageRoute,
} from "../ContributorMatchBulkUpdatePage/ContributorMatchBulkUpdatePage";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import ApiService from "services/apiService";
import { setAppToast } from "redux/reducers/appSlice";

export const useContributorMatchMenuItems = (props: {
  permission: Permission;
  setSelectedIds: (value: number[]) => void;
  loadList: () => void;
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const menuItems: ListMenuItem[] = [];

  if (isAuthorized(props.permission, PermissionAction.Update))
    menuItems.push({
      label: "Update",
      action: (selectedIds: number[]) =>
        navigate(contributorMatchBulkUpdatePageRoute.getPath(), {
          state: { selectedIds: selectedIds } as ContributorMatchBulkUpdatePageState,
        }),
    });

  if (isAuthorized(props.permission, PermissionAction.BulkLock))
    menuItems.push({
      label: "Unlock",
      action: (selectedIds: number[]) => {
        if (window.confirm(BULK_UNLOCK_WARNING))
          ApiService.contributorMatches.postBulkUnlock(selectedIds).then(() => {
            props.setSelectedIds([]);
            dispatch(setAppToast(newToast("success")));
            props.loadList();
          });
      },
    });

  if (isAuthorized(props.permission, PermissionAction.BulkLock))
    menuItems.push({
      label: <Typography color="error">Lock</Typography>,
      action: (selectedIds: number[]) => {
        if (window.confirm(BULK_LOCK_WARNING))
          ApiService.contributorMatches.postBulkLock(selectedIds).then(() => {
            props.setSelectedIds([]);
            dispatch(setAppToast(newToast("success")));
            props.loadList();
          });
      },
    });

  if (isAuthorized(props.permission, PermissionAction.BulkDelete))
    menuItems.push({
      label: <Typography color="error">Delete</Typography>,
      action: (selectedIds: number[]) => {
        if (window.confirm(BULK_DELETE_WARNING))
          ApiService.contributorMatches.postBulkDelete(selectedIds).then(() => {
            props.setSelectedIds([]);
            dispatch(setAppToast(newToast("success")));
            props.loadList();
          });
      },
    });

  return menuItems;
};
